import { forwardRef, useRef } from 'react';
import { bool, string, element, func, arrayOf, shape } from 'prop-types';
import { FocusOn } from 'react-focus-on';
import { CSSTransition } from 'react-transition-group';
import '../../constants/culture.js';
import { FocusableProvider } from '../../hooks/useFocusable.js';
import { useTheme } from 'styled-components';
import 'react-error-boundary';
import '../../theme/globalStyles.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import '../../theme/base/index.js';
import '../../theme/baseFit/index.js';
import '../../theme/pureGym/index.js';
import '../../theme/fitnessWorld/index.js';
import { Button } from '../button/index.js';
import '../icons/generated/360Tour.js';
import '../icons/generated/Accessibility.js';
import '../icons/generated/AccountCircle.js';
import '../icons/generated/Account.js';
import '../icons/generated/ArrowDownAlt.js';
import '../icons/generated/ArrowDown.js';
import '../icons/generated/ArrowLeft.js';
import '../icons/generated/ArrowRight.js';
import '../icons/generated/ArrowUpAlt.js';
import '../icons/generated/ArrowUp.js';
import '../icons/generated/Asterisk.js';
import '../icons/generated/Book.js';
import '../icons/generated/Building.js';
import '../icons/generated/Calendar.js';
import '../icons/generated/Chat.js';
import '../icons/generated/CheckCircle.js';
import '../icons/generated/Check.js';
import '../icons/generated/CircleEmpty.js';
import '../icons/generated/ClassEndurance.js';
import '../icons/generated/ClassFatburn.js';
import '../icons/generated/ClassFullbody.js';
import '../icons/generated/ClassMobility.js';
import '../icons/generated/ClassStrength.js';
import '../icons/generated/ClassTargetArea.js';
import '../icons/generated/ClassTone.js';
import '../icons/generated/ClassWellbeing.js';
import '../icons/generated/Clock.js';
import { IconClose } from '../icons/generated/Close.js';
import '../icons/generated/ColorPalette.js';
import '../icons/generated/ColorPicker.js';
import '../icons/generated/CookieBite.js';
import '../icons/generated/CreditCard.js';
import '../icons/generated/Cvv.js';
import '../icons/generated/Dash.js';
import '../icons/generated/Documents.js';
import '../icons/generated/DoorOpen.js';
import '../icons/generated/Email.js';
import '../icons/generated/Facebook.js';
import '../icons/generated/FullscreenExit.js';
import '../icons/generated/Fullscreen.js';
import '../icons/generated/Grid.js';
import '../icons/generated/GymFeature100FreeClasses.js';
import '../icons/generated/GymFeature150FreeClasses.js';
import '../icons/generated/GymFeature200FreeClasses.js';
import '../icons/generated/GymFeature200Kit.js';
import '../icons/generated/GymFeature200KitMachine.js';
import '../icons/generated/GymFeature220Kit.js';
import '../icons/generated/GymFeature2Floors.js';
import '../icons/generated/GymFeature3Floors.js';
import '../icons/generated/GymFeature40FreeClasses.js';
import '../icons/generated/GymFeature50FreeClasses.js';
import '../icons/generated/GymFeature50Kg.js';
import '../icons/generated/GymFeature60FreeClasses.js';
import '../icons/generated/GymFeature70FreeClasses.js';
import '../icons/generated/GymFeature80FreeClasses.js';
import '../icons/generated/GymFeature90FreeClasses.js';
import '../icons/generated/GymFeatureApp.js';
import '../icons/generated/GymFeatureBodyTrak.js';
import '../icons/generated/GymFeatureClasses.js';
import '../icons/generated/GymFeatureCleaning.js';
import '../icons/generated/GymFeatureDigitalClass.js';
import '../icons/generated/GymFeatureDigitalCycle.js';
import '../icons/generated/GymFeatureDumbbells50Kg.js';
import '../icons/generated/GymFeatureFreeParking.js';
import '../icons/generated/GymFeatureFreeWeightsKettle.js';
import '../icons/generated/GymFeatureHydromassage.js';
import '../icons/generated/GymFeatureKeyFob.js';
import '../icons/generated/GymFeatureLadiesOnlyArea.js';
import '../icons/generated/GymFeatureLargeFreeWeightsArea.js';
import '../icons/generated/GymFeatureNewKit.js';
import '../icons/generated/GymFeatureNewlyRefurbished.js';
import '../icons/generated/GymFeatureOpen24Hours.js';
import '../icons/generated/GymFeaturePtAvailable.js';
import '../icons/generated/GymFeatureQualityKit.js';
import '../icons/generated/GymFeatureShowers.js';
import '../icons/generated/GymFeatureYanga.js';
import '../icons/generated/GymPackageFeatureAdvancedBooking.js';
import '../icons/generated/GymPackageFeatureBenefits.js';
import '../icons/generated/GymPackageFeatureBuddy.js';
import '../icons/generated/GymPackageFeatureMultiGym.js';
import '../icons/generated/Hand.js';
import '../icons/generated/Heart.js';
import '../icons/generated/IdCard.js';
import '../icons/generated/Info.js';
import '../icons/generated/Instagram.js';
import '../icons/generated/List.js';
import '../icons/generated/Locale.js';
import '../icons/generated/Lock.js';
import '../icons/generated/LogIn.js';
import '../icons/generated/LogOut.js';
import '../icons/generated/MapPin.js';
import '../icons/generated/Map.js';
import '../icons/generated/Menu.js';
import '../icons/generated/Messenger.js';
import '../icons/generated/MultiGym.js';
import '../icons/generated/Nfc.js';
import '../icons/generated/NoContract.js';
import '../icons/generated/Phone.js';
import '../icons/generated/Plus.js';
import '../icons/generated/QrCode.js';
import '../icons/generated/Search.js';
import '../icons/generated/Snowflake.js';
import '../icons/generated/StarHalf.js';
import '../icons/generated/Star.js';
import '../icons/generated/Strava.js';
import '../icons/generated/Target.js';
import '../icons/generated/ThemeDark.js';
import '../icons/generated/ThemeLight.js';
import '../icons/generated/Ticket.js';
import '../icons/generated/Tiktok.js';
import '../icons/generated/Times.js';
import '../icons/generated/Twitter.js';
import '../icons/generated/Unlock.js';
import '../icons/generated/Warning.js';
import '../icons/generated/Weights.js';
import '../icons/generated/Whatsapp.js';
import '../icons/generated/Wifi.js';
import '../icons/generated/Youtube.js';
import { MenuProvider, useMenu } from './menuContext.js';
import { NAV_VARIANTS } from './constants.js';
export { NAV_VARIANTS } from './constants.js';
import { Wrapper, DropdownContainer, GlobalNavWrapper, CloseButton, Overlay, MenuWrapper } from './styles.js';
import { MenuPanel } from './menuPanel.js';
import { BUTTON_VARIANTS } from '../button/constants.js';

const Container = _ref => {
  let {
    buttonProps,
    trigger,
    unmountOnExit,
    ...rest
  } = _ref;
  const {
    direction,
    isOpen,
    labels,
    menuData,
    menuLevel,
    options,
    prevMenuLevel,
    resetMenu,
    setIsOpen
  } = useMenu();
  const {
    placement,
    variant,
    width
  } = options;
  const isRtl = direction === 'rtl';
  const triggerRef = useRef(null);
  const {
    transitions
  } = useTheme();

  /** Are we moving back to a parent (up) or to a sub-menu (down)? */
  const menuDirection = menuLevel < prevMenuLevel ? 'up' : 'down';
  const isOddLevel = !!(menuLevel % 2);

  /** Set panel data based on menu state */
  const nextPanel = menuDirection === 'up' ? menuData[menuLevel + 1] : menuData[menuLevel - 1];
  const panelA = !isOddLevel ? menuData[menuLevel] : nextPanel;
  const panelB = isOddLevel ? menuData[menuLevel] : nextPanel;

  /**
   * Menu close - we reset the level separately in the transition
   * `onExited` callback to avoid a visible shift.
   */
  const closeMenu = () => {
    setIsOpen(false);
  };
  const onExited = () => {
    resetMenu();
    triggerRef.current?.focus();
  };
  const menuContent = /*#__PURE__*/jsxs(MenuWrapper, {
    width: width,
    children: [/*#__PURE__*/jsx(MenuPanel, {
      data: panelA,
      visible: !isOddLevel
    }), /*#__PURE__*/jsx(MenuPanel, {
      data: panelB,
      visible: isOddLevel
    })]
  });
  return /*#__PURE__*/jsxs(Wrapper, {
    children: [/*#__PURE__*/jsx(Button, {
      "aria-expanded": isOpen,
      "aria-haspopup": true,
      onClick: () => setIsOpen(!isOpen),
      ref: triggerRef,
      variant: BUTTON_VARIANTS.PLAIN,
      ...buttonProps,
      children: trigger
    }), /*#__PURE__*/jsx(FocusOn, {
      enabled: isOpen,
      onClickOutside: closeMenu,
      onEscapeKey: closeMenu,
      returnFocus: true,
      children: /*#__PURE__*/jsx(CSSTransition, {
        appear: true,
        in: isOpen,
        onExited: onExited,
        timeout: transitions.default,
        unmountOnExit: unmountOnExit,
        children: variant === NAV_VARIANTS.DROPDOWN ? /*#__PURE__*/jsx(DropdownContainer, {
          placement: placement,
          children: /*#__PURE__*/jsx("nav", {
            "aria-label": labels?.nav,
            ...rest,
            children: menuContent
          })
        }) : /*#__PURE__*/jsxs(GlobalNavWrapper, {
          isRtl: isRtl,
          children: [/*#__PURE__*/jsxs(CloseButton, {
            variant: BUTTON_VARIANTS.PLAIN,
            onClick: closeMenu,
            children: [/*#__PURE__*/jsx(IconClose, {
              "aria-hidden": true
            }), /*#__PURE__*/jsx("span", {
              children: labels.close
            })]
          }), /*#__PURE__*/jsx("nav", {
            "aria-label": labels?.nav,
            ...rest,
            children: menuContent
          })]
        })
      })
    }), variant === NAV_VARIANTS.GLOBAL && /*#__PURE__*/jsx(CSSTransition, {
      appear: true,
      in: isOpen,
      timeout: transitions.default,
      unmountOnExit: true,
      mountOnEnter: true,
      children: /*#__PURE__*/jsx(Overlay, {})
    })]
  });
};
/**
 * Nav expects `data` to be an array of objects that
 * make up your menu. Objects with children display their
 * sub-menu onClick, otherwise they are just links or buttons.
 *
 * For RTL languages to animate correctly, the component uses the
 * `dir="rtl"` CSS selector, so you need to ensure it is present
 * on the `html` tag.
 */
const Nav = /*#__PURE__*/forwardRef(function Nav(_ref2, ref) {
  let {
    buttonProps,
    data,
    labels,
    placement = 'bottom-end',
    trigger,
    variant = NAV_VARIANTS.DROPDOWN,
    width = 'auto',
    unmountOnExit = false,
    ...rest
  } = _ref2;
  return /*#__PURE__*/jsx(MenuProvider, {
    data: data,
    labels: labels,
    options: {
      placement,
      variant,
      width
    },
    children: /*#__PURE__*/jsx(FocusableProvider, {
      children: /*#__PURE__*/jsx(Container, {
        ref: ref,
        trigger: trigger,
        buttonProps: buttonProps,
        unmountOnExit: unmountOnExit,
        ...rest
      })
    })
  });
});
const menuItemShape = {
  active: bool,
  divider: bool,
  href: string,
  icon: element,
  name: string.isRequired,
  onClick: func,
  primary: bool,
  rtl: bool,
  to: string,
  type: string
};

// Recursively set the children prop
menuItemShape.children = arrayOf(shape(menuItemShape));

export { Nav };
